var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.869 10.7281C19.8698 10.0466 19.8118 9.3664 19.6956 8.69482H10.1998V12.546H15.6385C15.5272 13.1611 15.2917 13.7475 14.946 14.2697C14.6004 14.792 14.1519 15.2393 13.6275 15.5848V18.0846H16.8734C18.7739 16.3444 19.869 13.771 19.869 10.7281Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1997 20.5C12.917 20.5 15.2049 19.6139 16.8734 18.0862L13.6274 15.5864C12.724 16.1947 11.5605 16.5419 10.1997 16.5419C7.57334 16.5419 5.34414 14.7836 4.54699 12.4143H1.20319V14.9906C2.04126 16.6467 3.32635 18.0389 4.915 19.0118C6.50364 19.9847 8.3333 20.4999 10.1997 20.5Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54698 12.414C4.12556 11.1724 4.12556 9.82793 4.54698 8.58639V6.01013H1.20317C0.498154 7.40333 0.130981 8.94096 0.130981 10.5002C0.130981 12.0594 0.498154 13.597 1.20317 14.9902L4.54698 12.414Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1997 4.45879C11.6357 4.43549 13.0232 4.97429 14.0624 5.95872L16.9363 3.10469C15.1139 1.40488 12.6997 0.471659 10.1997 0.500656C8.3333 0.500741 6.50364 1.01598 4.915 1.98886C3.32635 2.96174 2.04126 4.35397 1.20319 6.0101L4.54699 8.58636C5.34414 6.21704 7.57334 4.45879 10.1997 4.45879Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamil);
export default __webpack_public_path__ + "static/media/gamil.469ecb7aa919dcd8833c074bafa85d46.svg";
export { ForwardRef as ReactComponent };